import questionImage from '../documents/images/Overview image.png'

export default function OverviewImage() {
    

    return (
        <img id="section-image" className="section-image section-image-lg " src={questionImage} />
    )
}